var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVisaCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31.996,
    height: 22.531,
    viewBox: "0 0 31.996 22.531",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_55977",
    transform: "translate(-647.614 -636.441)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3",
    width: 31.996,
    height: 22.531,
    rx: 2,
    transform: "translate(647.614 636.441)",
    fill: "#0066b2"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3",
    transform: "translate(653.4 644.721)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    d: "M780.051,727.458h-1.666l1.042-6.4h1.667Z",
    transform: "translate(-771.197 -720.942)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    d: "M711.723,721.057l-1.589,4.4-.188-.948h0l-.561-2.878a.713.713,0,0,0-.791-.576h-2.626l-.031.108a6.223,6.223,0,0,1,1.743.732l1.448,5.561h1.736l2.651-6.4Z",
    transform: "translate(-705.938 -720.943)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    d: "M856.442,727.458h1.53l-1.334-6.4H855.3a.766.766,0,0,0-.769.477l-2.485,5.924h1.737l.347-.951h2.119Zm-1.834-2.264.876-2.4.493,2.4Z",
    transform: "translate(-837.549 -720.943)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    d: "M810.276,721.556l.238-1.375a4.812,4.812,0,0,0-1.5-.279c-.827,0-2.791.362-2.791,2.119,0,1.654,2.3,1.674,2.3,2.543s-2.067.713-2.75.165l-.248,1.437a4.668,4.668,0,0,0,1.881.362c1.137,0,2.853-.589,2.853-2.191,0-1.664-2.326-1.819-2.326-2.543S809.563,721.163,810.276,721.556Z",
    transform: "translate(-795.652 -719.902)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    d: "M709.946,724.512l-.561-2.878a.713.713,0,0,0-.791-.576h-2.626l-.031.108a6.459,6.459,0,0,1,2.474,1.242A4.991,4.991,0,0,1,709.946,724.512Z",
    transform: "translate(-705.938 -720.943)",
    fill: "#f9a533"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisaCard);
export default __webpack_public_path__ + "static/media/visa-card.cbeadaac4c1c3cc4200e2bdc0eb68335.svg";
export { ForwardRef as ReactComponent };